(function initializeBimSchvRules(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;

    if (require.main === module) {
      const report = api.runSelfTests();
      report.results.forEach((result) => {
        const marker = result.passed ? 'PASS' : 'FAIL';
        console.log(`${marker}: ${result.name}${result.message ? ` — ${result.message}` : ''}`);
      });
      console.log(`BImSchV rules self-test: ${report.passed}/${report.total} passed`);
      if (report.failed > 0) process.exitCode = 1;
    }
  } else {
    root.OfenerlebnisBimSchvRules = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function createBimSchvRules() {
  'use strict';

  const RULESET = Object.freeze({
    id: 'OE-BIMSCHV',
    version: '1.0.0',
    legalReviewDate: '2026-08-10',
  });

  const STATUS = Object.freeze({
    PASS: 'PASS',
    REVIEW: 'REVIEW',
    ACTION_REQUIRED: 'ACTION_REQUIRED',
    EXCEPTION: 'EXCEPTION',
    UNKNOWN: 'UNKNOWN',
  });

  const REASON_CODES = Object.freeze({
    OLD_LIMITS_PROVEN: 'OLD_LIMITS_PROVEN',
    OLD_NO_PROOF_DEADLINE_EXPIRED: 'OLD_NO_PROOF_DEADLINE_EXPIRED',
    OLD_LIMIT_EXCEEDED: 'OLD_LIMIT_EXCEEDED',
    OLD_PROOF_INCOMPLETE: 'OLD_PROOF_INCOMPLETE',
    PRE_1950_EXCEPTION: 'PRE_1950_EXCEPTION',
    SOLE_HEAT_SOURCE_EXCEPTION: 'SOLE_HEAT_SOURCE_EXCEPTION',
    OPEN_FIREPLACE_EXCEPTION: 'OPEN_FIREPLACE_EXCEPTION',
    NONCOMMERCIAL_STOVE_EXCEPTION: 'NONCOMMERCIAL_STOVE_EXCEPTION',
    GROUND_STOVE_EXCEPTION: 'GROUND_STOVE_EXCEPTION',
    MASONRY_INSERT_FILTER_PROVEN: 'MASONRY_INSERT_FILTER_PROVEN',
    MASONRY_INSERT_FILTER_UNKNOWN: 'MASONRY_INSERT_FILTER_UNKNOWN',
    STAGE_1_TYPE_PROOF: 'STAGE_1_TYPE_PROOF',
    STAGE_1_PROOF_MISSING: 'STAGE_1_PROOF_MISSING',
    STAGE_1_PROOF_INCOMPLETE: 'STAGE_1_PROOF_INCOMPLETE',
    STAGE_1_LIMIT_EXCEEDED: 'STAGE_1_LIMIT_EXCEEDED',
    STAGE_2_TYPE_PROOF: 'STAGE_2_TYPE_PROOF',
    STAGE_2_PROOF_MISSING: 'STAGE_2_PROOF_MISSING',
    STAGE_2_PROOF_INCOMPLETE: 'STAGE_2_PROOF_INCOMPLETE',
    STAGE_2_LIMIT_EXCEEDED: 'STAGE_2_LIMIT_EXCEEDED',
    GROUND_STOVE_POST_2014: 'GROUND_STOVE_POST_2014',
    OFFICIAL_EXCEPTION: 'OFFICIAL_EXCEPTION',
    UNKNOWN_APPLIANCE: 'UNKNOWN_APPLIANCE',
    UNKNOWN_DATE: 'UNKNOWN_DATE',
    OUT_OF_SCOPE: 'OUT_OF_SCOPE',
  });

  const SOURCE_CATALOG = Object.freeze({
    BIMSCHV_SECTION_2: Object.freeze({
      id: 'BIMSCHV_SECTION_2',
      document: '1. BImSchV',
      provision: '§ 2',
      label: '§ 2 1. BImSchV — Begriffsbestimmungen',
    }),
    BIMSCHV_SECTION_4: Object.freeze({
      id: 'BIMSCHV_SECTION_4',
      document: '1. BImSchV',
      provision: '§ 4',
      label: '§ 4 1. BImSchV — Allgemeine Anforderungen',
    }),
    BIMSCHV_SECTION_4_3: Object.freeze({
      id: 'BIMSCHV_SECTION_4_3',
      document: '1. BImSchV',
      provision: '§ 4 Abs. 3',
      label: '§ 4 Abs. 3 1. BImSchV — Emissionsgrenzwerte und Mindestwirkungsgrade',
    }),
    BIMSCHV_SECTION_4_4: Object.freeze({
      id: 'BIMSCHV_SECTION_4_4',
      document: '1. BImSchV',
      provision: '§ 4 Abs. 4',
      label: '§ 4 Abs. 4 1. BImSchV — Betriebsbeschränkung für offene Kamine',
    }),
    BIMSCHV_SECTION_4_5: Object.freeze({
      id: 'BIMSCHV_SECTION_4_5',
      document: '1. BImSchV',
      provision: '§ 4 Abs. 5',
      label: '§ 4 Abs. 5 1. BImSchV — Anforderungen an Grundöfen',
    }),
    BIMSCHV_SECTION_21: Object.freeze({
      id: 'BIMSCHV_SECTION_21',
      document: '1. BImSchV',
      provision: '§ 21',
      label: '§ 21 1. BImSchV — Überwachung neuer Anlagen',
    }),
    BIMSCHV_SECTION_22: Object.freeze({
      id: 'BIMSCHV_SECTION_22',
      document: '1. BImSchV',
      provision: '§ 22',
      label: '§ 22 1. BImSchV — Ausnahmen',
    }),
    BIMSCHV_SECTION_26: Object.freeze({
      id: 'BIMSCHV_SECTION_26',
      document: '1. BImSchV',
      provision: '§ 26',
      label: '§ 26 1. BImSchV — Übergangsregelung für Einzelraumfeuerungsanlagen',
    }),
    BIMSCHV_SECTION_26_1: Object.freeze({
      id: 'BIMSCHV_SECTION_26_1',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 1',
      label: '§ 26 Abs. 1 1. BImSchV — Nachweis der Altanlagen-Grenzwerte',
    }),
    BIMSCHV_SECTION_26_2: Object.freeze({
      id: 'BIMSCHV_SECTION_26_2',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 2',
      label: '§ 26 Abs. 2 1. BImSchV — Übergangsfristen für Altanlagen',
    }),
    BIMSCHV_SECTION_26_3_1: Object.freeze({
      id: 'BIMSCHV_SECTION_26_3_1',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 3 Nr. 1',
      label: '§ 26 Abs. 3 Nr. 1 1. BImSchV — Ausnahme für nichtgewerbliche Herde und Backöfen',
    }),
    BIMSCHV_SECTION_26_3_2: Object.freeze({
      id: 'BIMSCHV_SECTION_26_3_2',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 3 Nr. 2',
      label: '§ 26 Abs. 3 Nr. 2 1. BImSchV — Ausnahme für offene Kamine',
    }),
    BIMSCHV_SECTION_26_3_3: Object.freeze({
      id: 'BIMSCHV_SECTION_26_3_3',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 3 Nr. 3',
      label: '§ 26 Abs. 3 Nr. 3 1. BImSchV — Ausnahme für Grundöfen',
    }),
    BIMSCHV_SECTION_26_3_4: Object.freeze({
      id: 'BIMSCHV_SECTION_26_3_4',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 3 Nr. 4',
      label: '§ 26 Abs. 3 Nr. 4 1. BImSchV — Ausnahme bei ausschließlicher Wärmeversorgung',
    }),
    BIMSCHV_SECTION_26_3_5: Object.freeze({
      id: 'BIMSCHV_SECTION_26_3_5',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 3 Nr. 5',
      label: '§ 26 Abs. 3 Nr. 5 1. BImSchV — Ausnahme für Anlagen vor 1950',
    }),
    BIMSCHV_SECTION_26_4: Object.freeze({
      id: 'BIMSCHV_SECTION_26_4',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 4',
      label: '§ 26 Abs. 4 1. BImSchV — Eingemauerte Einsätze und Staubminderung',
    }),
    BIMSCHV_SECTION_26_6: Object.freeze({
      id: 'BIMSCHV_SECTION_26_6',
      document: '1. BImSchV',
      provision: '§ 26 Abs. 6',
      label: '§ 26 Abs. 6 1. BImSchV — Anforderungen der Stufe 1',
    }),
    BIMSCHV_ANNEX_4: Object.freeze({
      id: 'BIMSCHV_ANNEX_4',
      document: '1. BImSchV',
      provision: 'Anlage 4',
      label: 'Anlage 4 1. BImSchV — Emissionsgrenzwerte und Mindestwirkungsgrade',
    }),
    BIMSCHV_ANNEX_4_1: Object.freeze({
      id: 'BIMSCHV_ANNEX_4_1',
      document: '1. BImSchV',
      provision: 'Anlage 4 Nr. 1',
      label: 'Anlage 4 Nr. 1 1. BImSchV — Emissionsgrenzwerte und Mindestwirkungsgrade',
    }),
  });

  const OLD_LIMITS = Object.freeze({
    co: 4.0,
    dust: 0.15,
  });

  const STAGE_LIMITS = Object.freeze({
    room_heater_flat: freezeThreshold('Raumheizer mit Flachfeuerung', 2.0, 0.075, 1.25, 0.04, 73),
    room_heater_fill: freezeThreshold('Raumheizer mit Füllfeuerung', 2.5, 0.075, 1.25, 0.04, 70),
    storage_single: freezeThreshold('Speichereinzelfeuerstätte', 2.0, 0.075, 1.25, 0.04, 75),
    fireplace_insert_closed: freezeThreshold(
      'Kamineinsatz mit geschlossener Betriebsweise',
      2.0,
      0.075,
      1.25,
      0.04,
      75
    ),
    tiled_stove_insert_flat: freezeThreshold('Kachelofeneinsatz mit Flachfeuerung', 2.0, 0.075, 1.25, 0.04, 80),
    tiled_stove_insert_fill: freezeThreshold('Kachelofeneinsatz mit Füllfeuerung', 2.5, 0.075, 1.25, 0.04, 80),
    stove: freezeThreshold('Herd', 3.0, 0.075, 1.5, 0.04, 70),
    heating_stove: freezeThreshold('Heizungsherd', 3.5, 0.075, 1.5, 0.04, 75),
    pellet_stove_no_water: freezeThreshold('Pelletofen ohne Wassertasche', 0.4, 0.05, 0.25, 0.03, 85),
    pellet_stove_water: freezeThreshold('Pelletofen mit Wassertasche', 0.4, 0.03, 0.25, 0.02, 90),
    other_heating: freezeThreshold('Sonstige Feuerstätte zum Beheizen', 2.0, 0.075, 1.25, 0.04, 73),
    other_cooking: freezeThreshold('Sonstige Feuerstätte zum Kochen oder Backen', 3.0, 0.075, 1.5, 0.04, 70),
  });

  const APPLIANCE_TYPES = Object.freeze({
    room_heater_flat: 'Raumheizer mit Flachfeuerung',
    room_heater_fill: 'Raumheizer mit Füllfeuerung',
    storage_single: 'Speichereinzelfeuerstätte',
    fireplace_insert_closed: 'Kamineinsatz, geschlossene Betriebsweise',
    tiled_stove_insert_flat: 'Kachelofeneinsatz mit Flachfeuerung',
    tiled_stove_insert_fill: 'Kachelofeneinsatz mit Füllfeuerung',
    stove: 'Herd',
    heating_stove: 'Heizungsherd',
    pellet_stove_no_water: 'Pelletofen ohne Wassertasche',
    pellet_stove_water: 'Pelletofen mit Wassertasche',
    other_heating: 'Sonstige Einzelraumfeuerungsanlage zum Beheizen',
    other_cooking: 'Sonstige Einzelraumfeuerungsanlage zum Kochen oder Backen',
    open_fireplace: 'Offener Kamin',
    ground_stove: 'Grundofen',
    unknown: 'Nicht sicher zuordenbar',
  });

  const DEADLINES = Object.freeze([
    Object.freeze({ from: null, to: '1974-12-31', deadline: '2014-12-31', label: 'bis einschließlich 31.12.1974' }),
    Object.freeze({ from: '1975-01-01', to: '1984-12-31', deadline: '2017-12-31', label: '01.01.1975 bis 31.12.1984' }),
    Object.freeze({ from: '1985-01-01', to: '1994-12-31', deadline: '2020-12-31', label: '01.01.1985 bis 31.12.1994' }),
    Object.freeze({ from: '1995-01-01', to: '2010-03-21', deadline: '2024-12-31', label: '01.01.1995 bis 21.03.2010' }),
  ]);

  function freezeThreshold(label, stage1Co, stage1Dust, stage2Co, stage2Dust, efficiency) {
    return Object.freeze({
      label,
      stage1: Object.freeze({ co: stage1Co, dust: stage1Dust, efficiency }),
      stage2: Object.freeze({ co: stage2Co, dust: stage2Dust, efficiency }),
    });
  }

  function normalizeNumber(value, maximum) {
    if (value === '' || value === null || typeof value === 'undefined') return null;
    const number = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
    if (!Number.isFinite(number) || number < 0) return null;
    if (typeof maximum === 'number' && number > maximum) return null;
    return number;
  }

  function normalizeBoolean(value) {
    return value === true || value === 'true' || value === '1' || value === 1 || value === 'on';
  }

  function normalizeInput(input) {
    const source = input && typeof input === 'object' ? input : {};
    return {
      scopeConfirmed: normalizeBoolean(source.scopeConfirmed),
      applianceType: typeof source.applianceType === 'string' ? source.applianceType : '',
      constructionDate: typeof source.constructionDate === 'string' ? source.constructionDate.trim() : '',
      dateUnknown: normalizeBoolean(source.dateUnknown),
      officialException: normalizeBoolean(source.officialException),
      manufacturedBefore1950Proven: normalizeBoolean(source.manufacturedBefore1950Proven),
      soleHeatSource: normalizeBoolean(source.soleHeatSource),
      noncommercialStoveUnder15Kw: normalizeBoolean(source.noncommercialStoveUnder15Kw),
      masonryInsert: normalizeBoolean(source.masonryInsert),
      masonryDustReductionProof:
        typeof source.masonryDustReductionProof === 'string' ? source.masonryDustReductionProof : 'unknown',
      oldProofType: typeof source.oldProofType === 'string' ? source.oldProofType : 'none',
      typeProofStatus: typeof source.typeProofStatus === 'string' ? source.typeProofStatus : 'missing',
      co: normalizeNumber(source.co),
      dust: normalizeNumber(source.dust),
      efficiency: normalizeNumber(source.efficiency, 100),
    };
  }

  function parseIsoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const date = new Date(`${value}T00:00:00Z`);
    if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null;
    return value;
  }

  function sourceObjects(ids) {
    return ids.map((id) => SOURCE_CATALOG[id]).filter(Boolean);
  }

  function makeResult(input, definition) {
    const sourceIds = Array.from(new Set(definition.sourceIds || []));
    const sources = sourceObjects(sourceIds);
    return {
      status: definition.status,
      reasonCode: definition.reasonCode,
      title: definition.title,
      summary: definition.summary,
      details: definition.details || [],
      nextSteps: definition.nextSteps || [],
      legalBasis: sources.map((source) => source.label),
      sources,
      ruleSetId: RULESET.id,
      ruleVersion: RULESET.version,
      legalReviewDate: RULESET.legalReviewDate,
      evaluatedInputs: { ...input },
    };
  }

  function exceptionResult(input, reasonCode, title, detail, sourceIds) {
    return makeResult(input, {
      status: STATUS.EXCEPTION,
      reasonCode,
      title,
      summary:
        'Für Ihre Angaben greift eine besondere Einordnung. Daraus folgt keine uneingeschränkte oder rechtsverbindliche Betriebserlaubnis.',
      details: [detail],
      nextSteps: [
        'Lassen Sie die konkrete Anlage und alle weiteren Anforderungen durch die zuständige Schornsteinfegerin, den zuständigen Schornsteinfeger oder die Behörde prüfen.',
      ],
      sourceIds,
    });
  }

  function findDeadline(date, dateUnknown) {
    if (dateUnknown) {
      return {
        from: null,
        to: null,
        deadline: '2014-12-31',
        label: 'Datum nicht feststellbar',
      };
    }
    return DEADLINES.find((entry) => (!entry.from || date >= entry.from) && date <= entry.to) || null;
  }

  function evaluateOldInstallation(input, date) {
    if (input.masonryInsert) {
      if (input.masonryDustReductionProof === 'proven') {
        return makeResult(input, {
          status: STATUS.REVIEW,
          reasonCode: REASON_CODES.MASONRY_INSERT_FILTER_PROVEN,
          title: 'Besondere Regel für eingemauerten Einsatz',
          summary:
            'Für den eingemauerten Einsatz wurde ein Nachweis zur nachgeschalteten Staubminderung angegeben. Die besondere Regel des § 26 Abs. 4 ist gesondert zu prüfen.',
          details: [
            'Die normale Außerbetriebnahme-Logik für Altanlagen wurde nicht angewendet.',
            'Der konkrete Nachweis und die technische Ausführung müssen anlagenbezogen bestätigt werden.',
          ],
          nextSteps: ['Nachweis und Ausführung durch die zuständige Fachperson prüfen lassen.'],
          sourceIds: ['BIMSCHV_SECTION_26_4'],
        });
      }

      return makeResult(input, {
        status: STATUS.REVIEW,
        reasonCode: REASON_CODES.MASONRY_INSERT_FILTER_UNKNOWN,
        title: 'Nachweis zur Staubminderung erforderlich',
        summary:
          'Für den eingemauerten Einsatz ist die besondere Regel zur nachgeschalteten Staubminderung relevant; ein sicherer Nachweis wurde nicht angegeben.',
        details: ['Die normale Außerbetriebnahme-Logik wurde nicht automatisch angewendet.'],
        nextSteps: ['Art des Einsatzes und Nachweis zur Staubminderung fachlich klären lassen.'],
        sourceIds: ['BIMSCHV_SECTION_26_4'],
      });
    }

    if (input.oldProofType === 'none') {
      const deadline = findDeadline(date, input.dateUnknown);
      return makeResult(input, {
        status: STATUS.ACTION_REQUIRED,
        reasonCode: REASON_CODES.OLD_NO_PROOF_DEADLINE_EXPIRED,
        title: 'Nachweis fehlt und Übergangsfrist ist abgelaufen',
        summary:
          'Nach Ihren Angaben liegt kein anerkannter Nachweis vor. Die für diesen Errichtungszeitraum vorgesehene Übergangsfrist ist abgelaufen.',
        details: deadline
          ? [`Typschild-Zeitraum: ${deadline.label}.`, `Maßgebliche Frist: ${formatDate(deadline.deadline)}.`]
          : ['Für das angegebene Datum konnte keine Übergangsfrist zugeordnet werden.'],
        nextSteps: [
          'Prüfstandsmessbescheinigung oder Messnachweis suchen.',
          'Zulässige Nachrüstung, Austausch oder weitere Vorgehensweise fachlich klären lassen.',
        ],
        sourceIds: ['BIMSCHV_SECTION_26_2'],
      });
    }

    if (
      input.oldProofType === 'incomplete' ||
      !['manufacturer_test', 'chimney_sweep_measurement'].includes(input.oldProofType) ||
      input.co === null ||
      input.dust === null
    ) {
      return makeResult(input, {
        status: STATUS.REVIEW,
        reasonCode: REASON_CODES.OLD_PROOF_INCOMPLETE,
        title: 'Nachweis unvollständig',
        summary: 'Für die Altanlage fehlen entscheidungsrelevante Angaben oder ein vollständig anerkannter Nachweis.',
        details: ['Benötigt werden ein anerkannter Nachweis sowie CO- und Staubwert.'],
        nextSteps: ['Unterlagen vervollständigen und durch die zuständige Fachperson prüfen lassen.'],
        sourceIds: ['BIMSCHV_SECTION_26_1'],
      });
    }

    const exceeded = [];
    if (input.co > OLD_LIMITS.co) exceeded.push(`CO ${input.co} g/m³ über ${OLD_LIMITS.co} g/m³`);
    if (input.dust > OLD_LIMITS.dust) exceeded.push(`Staub ${input.dust} g/m³ über ${OLD_LIMITS.dust} g/m³`);

    if (exceeded.length > 0) {
      return makeResult(input, {
        status: STATUS.ACTION_REQUIRED,
        reasonCode: REASON_CODES.OLD_LIMIT_EXCEEDED,
        title: 'Mindestens ein Altanlagen-Grenzwert ist überschritten',
        summary: 'Die angegebenen Messwerte überschreiten mindestens einen im Check geprüften Grenzwert.',
        details: exceeded,
        nextSteps: ['Nachrüstung, Austausch oder behördlich abgestimmte Lösung fachlich prüfen lassen.'],
        sourceIds: ['BIMSCHV_SECTION_26_1'],
      });
    }

    return makeResult(input, {
      status: STATUS.PASS,
      reasonCode: REASON_CODES.OLD_LIMITS_PROVEN,
      title: 'Altanlagen-Grenzwerte nachgewiesen',
      summary: 'Nach Ihren Angaben sind die in diesem Check geprüften Anforderungen der 1. BImSchV erfüllt.',
      details: [
        `CO: ${input.co} g/m³ (maximal ${OLD_LIMITS.co} g/m³).`,
        `Staub: ${input.dust} g/m³ (maximal ${OLD_LIMITS.dust} g/m³).`,
      ],
      nextSteps: ['Nachweise dauerhaft aufbewahren und bei Prüfungen bereithalten.'],
      sourceIds: ['BIMSCHV_SECTION_26_1'],
    });
  }

  function evaluateStage(input, stageNumber) {
    const thresholdEntry = STAGE_LIMITS[input.applianceType];
    const reasonPrefix = `STAGE_${stageNumber}`;
    const stageKey = stageNumber === 1 ? 'stage1' : 'stage2';
    const limits = thresholdEntry && thresholdEntry[stageKey];
    const sourceIds =
      stageNumber === 1
        ? ['BIMSCHV_SECTION_4_3', 'BIMSCHV_SECTION_26_6', 'BIMSCHV_ANNEX_4_1']
        : ['BIMSCHV_SECTION_4_3', 'BIMSCHV_ANNEX_4_1'];

    if (!thresholdEntry || !limits) {
      return makeResult(input, {
        status: STATUS.UNKNOWN,
        reasonCode: REASON_CODES.UNKNOWN_APPLIANCE,
        title: 'Feuerstättenart nicht sicher zuordenbar',
        summary: 'Für die angegebene Feuerstättenart konnte keine belastbare automatische Zuordnung vorgenommen werden.',
        details: ['Es wurden keine Grenzwerte ersatzweise geraten.'],
        nextSteps: ['Feuerstättenart anhand Typenschild und Herstellerunterlagen fachlich bestimmen lassen.'],
        sourceIds: ['BIMSCHV_SECTION_2', 'BIMSCHV_ANNEX_4'],
      });
    }

    if (input.typeProofStatus === 'missing') {
      return makeResult(input, {
        status: STATUS.REVIEW,
        reasonCode: REASON_CODES[`${reasonPrefix}_PROOF_MISSING`],
        title: `Stufe-${stageNumber}-Nachweis fehlt`,
        summary: `Für die Anlage wurde kein vollständiger Typprüfungsnachweis für Stufe ${stageNumber} angegeben.`,
        details: [`Zugeordnete Feuerstättenart: ${thresholdEntry.label}.`],
        nextSteps: ['Herstellerunterlagen oder Typprüfungsnachweis beschaffen und prüfen lassen.'],
        sourceIds,
      });
    }

    if (
      input.typeProofStatus !== 'complete' ||
      input.co === null ||
      input.dust === null ||
      input.efficiency === null
    ) {
      return makeResult(input, {
        status: STATUS.REVIEW,
        reasonCode: REASON_CODES[`${reasonPrefix}_PROOF_INCOMPLETE`],
        title: `Stufe-${stageNumber}-Nachweis unvollständig`,
        summary: 'CO-, Staub- oder Wirkungsgradangabe fehlt oder der Nachweis ist nicht vollständig.',
        details: [`Zugeordnete Feuerstättenart: ${thresholdEntry.label}.`],
        nextSteps: ['Vollständigen Typprüfungsnachweis mit allen drei Werten beschaffen.'],
        sourceIds,
      });
    }

    const exceeded = [];
    if (input.co > limits.co) exceeded.push(`CO ${input.co} g/m³ über ${limits.co} g/m³`);
    if (input.dust > limits.dust) exceeded.push(`Staub ${input.dust} g/m³ über ${limits.dust} g/m³`);
    if (input.efficiency < limits.efficiency) {
      exceeded.push(`Wirkungsgrad ${input.efficiency} % unter ${limits.efficiency} %`);
    }

    if (exceeded.length > 0) {
      return makeResult(input, {
        status: STATUS.ACTION_REQUIRED,
        reasonCode: REASON_CODES[`${reasonPrefix}_LIMIT_EXCEEDED`],
        title: `Stufe-${stageNumber}-Anforderung nicht vollständig erfüllt`,
        summary: 'Mindestens eine angegebene Anforderung aus Anlage 4 wird nicht eingehalten.',
        details: exceeded,
        nextSteps: ['Typzuordnung und Nachweis fachlich prüfen sowie weiteres Vorgehen abstimmen lassen.'],
        sourceIds,
      });
    }

    return makeResult(input, {
      status: STATUS.PASS,
      reasonCode: REASON_CODES[`${reasonPrefix}_TYPE_PROOF`],
      title: `Stufe-${stageNumber}-Anforderungen nachgewiesen`,
      summary: 'Nach Ihren Angaben sind die in diesem Check geprüften Anforderungen der 1. BImSchV erfüllt.',
      details: [
        `Feuerstättenart: ${thresholdEntry.label}.`,
        `CO: ${input.co} g/m³ (maximal ${limits.co} g/m³).`,
        `Staub: ${input.dust} g/m³ (maximal ${limits.dust} g/m³).`,
        `Wirkungsgrad: ${input.efficiency} % (mindestens ${limits.efficiency} %).`,
      ],
      nextSteps: ['Typprüfungsnachweis aufbewahren und bei Prüfungen bereithalten.'],
      sourceIds,
    });
  }

  function evaluate(rawInput) {
    const input = normalizeInput(rawInput);

    if (!input.scopeConfirmed) {
      return makeResult(input, {
        status: STATUS.UNKNOWN,
        reasonCode: REASON_CODES.OUT_OF_SCOPE,
        title: 'Außerhalb des Prüfumfangs',
        summary:
          'Dieser Check bewertet ausschließlich Einzelraumfeuerungsanlagen für feste Brennstoffe im hier abgebildeten Umfang.',
        details: ['Andere Feuerungsanlagen werden nicht automatisch bewertet.'],
        nextSteps: ['Anlagenart fachlich bestimmen und geeignete Prüfstelle auswählen.'],
        sourceIds: ['BIMSCHV_SECTION_2'],
      });
    }

    if (input.officialException) {
      return exceptionResult(
        input,
        REASON_CODES.OFFICIAL_EXCEPTION,
        'Individueller behördlicher Bescheid angegeben',
        'Maßgeblich sind Inhalt, Bedingungen und Reichweite des individuellen Bescheids.',
        ['BIMSCHV_SECTION_22']
      );
    }

    if (input.manufacturedBefore1950Proven) {
      return exceptionResult(
        input,
        REASON_CODES.PRE_1950_EXCEPTION,
        'Herstellung oder Errichtung vor 1950 glaubhaft gemacht',
        'Die Ausnahme betrifft die Übergangsanforderungen des § 26 Abs. 1 und 2.',
        ['BIMSCHV_SECTION_26_3_5']
      );
    }

    if (!input.dateUnknown && !input.constructionDate) {
      return makeResult(input, {
        status: STATUS.UNKNOWN,
        reasonCode: REASON_CODES.UNKNOWN_DATE,
        title: 'Errichtungsdatum fehlt',
        summary: 'Ohne belastbaren Errichtungszeitraum kann die anzuwendende Regelstufe nicht bestimmt werden.',
        details: ['Es wurde keine Frist oder Regelstufe geraten.'],
        nextSteps: ['Typschild, Rechnung, Abnahmeunterlagen oder Herstellerunterlagen prüfen.'],
        sourceIds: ['BIMSCHV_SECTION_26', 'BIMSCHV_ANNEX_4'],
      });
    }

    const date = input.dateUnknown ? '0001-01-01' : parseIsoDate(input.constructionDate);
    if (!date) {
      return makeResult(input, {
        status: STATUS.UNKNOWN,
        reasonCode: REASON_CODES.UNKNOWN_DATE,
        title: 'Errichtungsdatum ist nicht verwertbar',
        summary: 'Das angegebene Datum konnte nicht eindeutig ausgewertet werden.',
        details: ['Erwartet wird ein gültiges Kalenderdatum.'],
        nextSteps: ['Datum anhand belastbarer Unterlagen prüfen.'],
        sourceIds: ['BIMSCHV_SECTION_26', 'BIMSCHV_ANNEX_4'],
      });
    }

    if (!Object.prototype.hasOwnProperty.call(APPLIANCE_TYPES, input.applianceType) || input.applianceType === 'unknown') {
      return makeResult(input, {
        status: STATUS.UNKNOWN,
        reasonCode: REASON_CODES.UNKNOWN_APPLIANCE,
        title: 'Feuerstättenart unbekannt',
        summary: 'Die Feuerstättenart konnte keiner Regelkategorie sicher zugeordnet werden.',
        details: ['Es wurden keine Grenzwerte einer ähnlichen Kategorie geraten.'],
        nextSteps: ['Typenschild und Herstellerunterlagen fachlich auswerten lassen.'],
        sourceIds: ['BIMSCHV_SECTION_2', 'BIMSCHV_ANNEX_4'],
      });
    }

    if (input.dateUnknown || date < '2010-03-22') {
      if (input.applianceType === 'open_fireplace') {
        return exceptionResult(
          input,
          REASON_CODES.OPEN_FIREPLACE_EXCEPTION,
          'Offener Kamin: besondere Einordnung',
          'Offene Kamine sind von § 26 Abs. 1 und 2 ausgenommen; andere Anforderungen, insbesondere § 4, bleiben gesondert relevant.',
          ['BIMSCHV_SECTION_26_3_2', 'BIMSCHV_SECTION_4_4']
        );
      }

      if (input.soleHeatSource) {
        return exceptionResult(
          input,
          REASON_CODES.SOLE_HEAT_SOURCE_EXCEPTION,
          'Ausschließliche Wärmeversorgung angegeben',
          'Die Ausnahme betrifft Anlagen in Wohneinheiten, deren Wärmeversorgung ausschließlich über diese Anlagen erfolgt.',
          ['BIMSCHV_SECTION_26_3_4']
        );
      }

      if (input.noncommercialStoveUnder15Kw) {
        if (!['stove', 'other_cooking'].includes(input.applianceType)) {
          return makeResult(input, {
            status: STATUS.REVIEW,
            reasonCode: REASON_CODES.UNKNOWN_APPLIANCE,
            title: 'Angaben zur Herd-Ausnahme widersprechen sich',
            summary: 'Die ausgewählte Feuerstättenart ist kein Herd oder eine sonstige Anlage zum Kochen oder Backen.',
            details: ['Die Ausnahme wurde nicht automatisch angewendet.'],
            nextSteps: ['Feuerstättenart und Nennwärmeleistung anhand der Unterlagen prüfen.'],
            sourceIds: ['BIMSCHV_SECTION_2', 'BIMSCHV_SECTION_26_3_1'],
          });
        }

        return exceptionResult(
          input,
          REASON_CODES.NONCOMMERCIAL_STOVE_EXCEPTION,
          'Nichtgewerblicher Herd oder Backofen unter 15 kW',
          'Die Ausnahme betrifft nichtgewerblich genutzte Herde und Backöfen unter 15 kW Nennwärmeleistung.',
          ['BIMSCHV_SECTION_26_3_1']
        );
      }

      if (input.applianceType === 'ground_stove') {
        return exceptionResult(
          input,
          REASON_CODES.GROUND_STOVE_EXCEPTION,
          'Grundofen: besondere Einordnung',
          'Die Ausnahme des § 26 wird nicht als uneingeschränkte Betriebserlaubnis interpretiert.',
          ['BIMSCHV_SECTION_26_3_3']
        );
      }

      return evaluateOldInstallation(input, date);
    }

    if (input.applianceType === 'ground_stove') {
      if (date >= '2015-01-01') {
        return makeResult(input, {
          status: STATUS.REVIEW,
          reasonCode: REASON_CODES.GROUND_STOVE_POST_2014,
          title: 'Grundofen ab 2015 fachlich prüfen',
          summary: 'Für den nach 2014 errichteten Grundofen wird keine automatische Tabellenbewertung vorgenommen.',
          details: ['Die Altanlagen-Ausnahme des § 26 wird nicht als allgemeine Betriebserlaubnis übertragen.'],
          nextSteps: ['Bauart, Nachweise und konkrete Anforderungen fachlich prüfen lassen.'],
          sourceIds: ['BIMSCHV_SECTION_4_5', 'BIMSCHV_ANNEX_4_1'],
        });
      }

      return makeResult(input, {
        status: STATUS.REVIEW,
        reasonCode: REASON_CODES.UNKNOWN_APPLIANCE,
        title: 'Grundofen zwischen 2010 und 2014 fachlich prüfen',
        summary: 'Für diese Kombination wird keine automatische Tabellenbewertung vorgenommen.',
        details: ['Die Altanlagen-Ausnahme des § 26 wurde nicht angewendet.'],
        nextSteps: ['Bauart und anwendbare Anforderungen fachlich bestimmen lassen.'],
        sourceIds: ['BIMSCHV_SECTION_4_5', 'BIMSCHV_ANNEX_4_1'],
      });
    }

    if (date <= '2014-12-31') return evaluateStage(input, 1);
    return evaluateStage(input, 2);
  }

  function formatDate(value) {
    const [year, month, day] = value.split('-');
    return `${day}.${month}.${year}`;
  }

  function runSelfTests() {
    const tests = [];
    const add = (name, input, expectedStatus, expectedReasonCode, assert) => {
      tests.push({ name, input, expectedStatus, expectedReasonCode, assert });
    };
    const oldBase = {
      scopeConfirmed: true,
      applianceType: 'room_heater_flat',
      constructionDate: '1999-06-01',
      oldProofType: 'manufacturer_test',
      co: 3.5,
      dust: 0.1,
    };

    add('Altgerät Grenzwerte eingehalten', oldBase, STATUS.PASS, REASON_CODES.OLD_LIMITS_PROVEN);
    add(
      'Altgerät exakt am Grenzwert',
      { ...oldBase, co: 4.0, dust: 0.15 },
      STATUS.PASS,
      REASON_CODES.OLD_LIMITS_PROVEN
    );
    add(
      'Altgerät Grenzwert überschritten',
      { ...oldBase, dust: 0.151 },
      STATUS.ACTION_REQUIRED,
      REASON_CODES.OLD_LIMIT_EXCEEDED
    );
    add(
      'Altgerät unvollständiger Nachweis',
      { ...oldBase, oldProofType: 'incomplete' },
      STATUS.REVIEW,
      REASON_CODES.OLD_PROOF_INCOMPLETE
    );
    add(
      'Altgerät ohne Nachweis',
      { ...oldBase, oldProofType: 'none' },
      STATUS.ACTION_REQUIRED,
      REASON_CODES.OLD_NO_PROOF_DEADLINE_EXPIRED
    );

    [
      ['Typschild bis 1974', '1970-01-01', '31.12.2014'],
      ['Typschild 1975 bis 1984', '1980-01-01', '31.12.2017'],
      ['Typschild 1985 bis 1994', '1990-01-01', '31.12.2020'],
      ['Typschild 1995 bis 21.03.2010', '2005-01-01', '31.12.2024'],
    ].forEach(([name, constructionDate, expectedDeadline]) => {
      add(
        name,
        { ...oldBase, constructionDate, oldProofType: 'none' },
        STATUS.ACTION_REQUIRED,
        REASON_CODES.OLD_NO_PROOF_DEADLINE_EXPIRED,
        (result) => result.details.some((detail) => detail.includes(expectedDeadline))
      );
    });
    add(
      'Datum nicht feststellbar ohne Nachweis',
      { ...oldBase, constructionDate: '', dateUnknown: true, oldProofType: 'none' },
      STATUS.ACTION_REQUIRED,
      REASON_CODES.OLD_NO_PROOF_DEADLINE_EXPIRED,
      (result) => result.details.some((detail) => detail.includes('31.12.2014'))
    );

    add(
      'Vor 1950 glaubhaft gemacht',
      { ...oldBase, manufacturedBefore1950Proven: true },
      STATUS.EXCEPTION,
      REASON_CODES.PRE_1950_EXCEPTION
    );
    add(
      'Einzige Wärmeversorgung',
      { ...oldBase, soleHeatSource: true },
      STATUS.EXCEPTION,
      REASON_CODES.SOLE_HEAT_SOURCE_EXCEPTION
    );
    add(
      'Offener Kamin',
      { ...oldBase, applianceType: 'open_fireplace' },
      STATUS.EXCEPTION,
      REASON_CODES.OPEN_FIREPLACE_EXCEPTION
    );
    add(
      'Grundofen',
      { ...oldBase, applianceType: 'ground_stove' },
      STATUS.EXCEPTION,
      REASON_CODES.GROUND_STOVE_EXCEPTION
    );
    add(
      'Nichtgewerblicher Herd unter 15 kW',
      { ...oldBase, applianceType: 'stove', noncommercialStoveUnder15Kw: true },
      STATUS.EXCEPTION,
      REASON_CODES.NONCOMMERCIAL_STOVE_EXCEPTION
    );
    add(
      'Eingemauerter Einsatz mit Nachweis',
      { ...oldBase, masonryInsert: true, masonryDustReductionProof: 'proven' },
      STATUS.REVIEW,
      REASON_CODES.MASONRY_INSERT_FILTER_PROVEN
    );
    add(
      'Eingemauerter Einsatz ohne sicheren Nachweis',
      { ...oldBase, masonryInsert: true, masonryDustReductionProof: 'unknown' },
      STATUS.REVIEW,
      REASON_CODES.MASONRY_INSERT_FILTER_UNKNOWN
    );

    Object.entries(STAGE_LIMITS).forEach(([applianceType, threshold]) => {
      add(
        `Stufe 1 ${threshold.label}`,
        {
          scopeConfirmed: true,
          applianceType,
          constructionDate: '2012-06-01',
          typeProofStatus: 'complete',
          co: threshold.stage1.co,
          dust: threshold.stage1.dust,
          efficiency: threshold.stage1.efficiency,
        },
        STATUS.PASS,
        REASON_CODES.STAGE_1_TYPE_PROOF
      );
      add(
        `Stufe 2 ${threshold.label}`,
        {
          scopeConfirmed: true,
          applianceType,
          constructionDate: '2018-06-01',
          typeProofStatus: 'complete',
          co: threshold.stage2.co,
          dust: threshold.stage2.dust,
          efficiency: threshold.stage2.efficiency,
        },
        STATUS.PASS,
        REASON_CODES.STAGE_2_TYPE_PROOF
      );
    });

    add(
      'Stufe 1 Nachweis fehlt',
      { scopeConfirmed: true, applianceType: 'room_heater_flat', constructionDate: '2012-01-01' },
      STATUS.REVIEW,
      REASON_CODES.STAGE_1_PROOF_MISSING
    );
    add(
      'Stufe 2 Nachweis fehlt',
      { scopeConfirmed: true, applianceType: 'room_heater_flat', constructionDate: '2018-01-01' },
      STATUS.REVIEW,
      REASON_CODES.STAGE_2_PROOF_MISSING
    );
    add(
      'Stufe 1 Grenzwert überschritten',
      {
        scopeConfirmed: true,
        applianceType: 'room_heater_flat',
        constructionDate: '2012-01-01',
        typeProofStatus: 'complete',
        co: 2.001,
        dust: 0.075,
        efficiency: 73,
      },
      STATUS.ACTION_REQUIRED,
      REASON_CODES.STAGE_1_LIMIT_EXCEEDED
    );
    add(
      'Stufe 2 Mindestwirkungsgrad unterschritten',
      {
        scopeConfirmed: true,
        applianceType: 'room_heater_flat',
        constructionDate: '2018-01-01',
        typeProofStatus: 'complete',
        co: 1.25,
        dust: 0.04,
        efficiency: 72.9,
      },
      STATUS.ACTION_REQUIRED,
      REASON_CODES.STAGE_2_LIMIT_EXCEEDED
    );
    add(
      'Ungültiger negativer Messwert',
      {
        scopeConfirmed: true,
        applianceType: 'room_heater_flat',
        constructionDate: '2012-01-01',
        typeProofStatus: 'complete',
        co: -1,
        dust: 0.075,
        efficiency: 73,
      },
      STATUS.REVIEW,
      REASON_CODES.STAGE_1_PROOF_INCOMPLETE
    );
    add(
      'Ungültiges Kalenderdatum',
      { scopeConfirmed: true, applianceType: 'room_heater_flat', constructionDate: '2026-02-30' },
      STATUS.UNKNOWN,
      REASON_CODES.UNKNOWN_DATE
    );
    add(
      'Grundofen nach 2014',
      { scopeConfirmed: true, applianceType: 'ground_stove', constructionDate: '2018-01-01' },
      STATUS.REVIEW,
      REASON_CODES.GROUND_STOVE_POST_2014
    );
    add(
      'Fehlendes Datum',
      { scopeConfirmed: true, applianceType: 'room_heater_flat' },
      STATUS.UNKNOWN,
      REASON_CODES.UNKNOWN_DATE
    );
    add(
      'Unbekannte Feuerstättenart',
      { scopeConfirmed: true, applianceType: 'unknown', constructionDate: '2018-01-01' },
      STATUS.UNKNOWN,
      REASON_CODES.UNKNOWN_APPLIANCE
    );
    add(
      'Unbekannte Feuerstättenart bei Altanlage',
      { ...oldBase, applianceType: 'unknown' },
      STATUS.UNKNOWN,
      REASON_CODES.UNKNOWN_APPLIANCE
    );
    add(
      'Widersprüchliche Herd-Ausnahme',
      { ...oldBase, applianceType: 'room_heater_flat', noncommercialStoveUnder15Kw: true },
      STATUS.REVIEW,
      REASON_CODES.UNKNOWN_APPLIANCE
    );
    add(
      'Behördliche Ausnahme',
      { scopeConfirmed: true, officialException: true },
      STATUS.EXCEPTION,
      REASON_CODES.OFFICIAL_EXCEPTION
    );
    add(
      'Out-of-Scope-Fall',
      { scopeConfirmed: false, applianceType: 'room_heater_flat' },
      STATUS.UNKNOWN,
      REASON_CODES.OUT_OF_SCOPE
    );

    const results = tests.map((test) => {
      try {
        const result = evaluate(test.input);
        const basePassed = result.status === test.expectedStatus && result.reasonCode === test.expectedReasonCode;
        const customPassed = typeof test.assert !== 'function' || test.assert(result);
        return {
          name: test.name,
          passed: basePassed && customPassed,
          message:
            basePassed && customPassed
              ? ''
              : `expected ${test.expectedStatus}/${test.expectedReasonCode}, received ${result.status}/${result.reasonCode}`,
        };
      } catch (error) {
        return { name: test.name, passed: false, message: error.message };
      }
    });

    const passed = results.filter((result) => result.passed).length;
    return Object.freeze({
      total: results.length,
      passed,
      failed: results.length - passed,
      results: Object.freeze(results),
    });
  }

  return Object.freeze({
    RULESET,
    STATUS,
    REASON_CODES,
    SOURCE_CATALOG,
    APPLIANCE_TYPES,
    STAGE_LIMITS,
    evaluate,
    runSelfTests,
  });
});
